var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vcl-table',{attrs:{"rows":_vm.rows,"columns":_vm.columns}}),_vm._v(" "),(!_vm.hideCircle)?[_c('br'),_c('br'),_vm._v(" "),_c('vue-content-loading',_vm._b({attrs:{"width":100,"height":100}},'vue-content-loading',_vm.$attrs,false),[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":_vm.radius}})])]:_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16705acb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./modules/Dashboard/Resources/assets/js/components/loaders/l-graph.vue
// module id = pgp+
// module chunks = 0